module.exports = __webpack_public_path__ + "static/media/8.7d585ff1.jpg";